import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1" }
const _hoisted_2 = { class: "flex items-center justify-between mt-4" }
const _hoisted_3 = {
  class: "block",
  href: "/massChangeEx.xlsx",
  download: "Шаблон для массовой смены даты и номера АВР.xlsx"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_act_number = _resolveComponent("act-number")!
  const _component_ftl_make_request_modal = _resolveComponent("ftl-make-request-modal")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_ftl_orders_filters = _resolveComponent("ftl-orders-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_mass_avr)
      ? (_openBlock(), _createBlock(_component_act_number, {
          key: 0,
          onToggle: _ctx.toggleMassAvr
        }, null, 8, ["onToggle"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ftl_make_request_modal, {
      "ftl-order-id": _ctx.requestForPaymentState.ftlOrderId,
      modelValue: _ctx.requestForPaymentState.isOpened,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestForPaymentState.isOpened) = $event)),
      onClose: _ctx.onCloseRequestForPayment,
      onSended: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFtl(_ctx.state.orders.pagination.current_page)))
    }, null, 8, ["ftl-order-id", "modelValue", "onClose"]),
    (_ctx.state.is_mass_excel)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          class: "auto",
          scrollable: "",
          title: "Массовая cмена даты и номера АВР",
          loading: _ctx.state.orders.is_loading,
          "confirm-disabled": _ctx.state.orders.is_loading,
          onCancel: _ctx.toggleMassExcel,
          onConfirm: _ctx.importActNumbers
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_file_reader, {
                type: "file",
                value: _ctx.state.mass_excel_file,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.mass_excel_file) = $event)),
                "is-invalid": _ctx.state_form$.mass_excel_file.$error,
                "validation-errors": _ctx.state_form$.mass_excel_file.$errors,
                accept: ".xlsx",
                disabled: _ctx.state.orders.is_loading,
                placeholder: "Выберите файл (.xlsx)"
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", _hoisted_3, [
                  _createVNode(_component_the_button, { class: "primary text small" }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" Скачать шаблон ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_page_title, { title: "FTL заказы" })
      ]),
      _createVNode(_component_ftl_orders_filters, {
        class: "mt-6",
        loading: _ctx.state.orders.is_loading,
        onSearch: _ctx.applyFilters,
        onResetted: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onResetted"]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.state.orders.is_failed && !_ctx.state.orders.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.orders.is_loading,
              text: "При получении списка произошла ошибка",
              "error-message": _ctx.state.orders.failure.error_state.message,
              "error-url": _ctx.state.orders.failure.error_state.url,
              "error-status": _ctx.state.orders.failure.error_state.status,
              onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadFtl(_ctx.state.orders.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.orders.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.orders.is_loading,
                  columns: _ctx.FtlColumns,
                  rows: _ctx.state.orders.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.state.limit,
                  "pagination-total-items": _ctx.state.orders.pagination.total_items,
                  "pagination-current-page": _ctx.state.orders.pagination.current_page,
                  "pagination-total-pages": _ctx.state.orders.pagination.total_pages,
                  onChangePage: _ctx.loadFtl,
                  onChangeLimit: _ctx.onLimitChange,
                  "quantity-loading": _ctx.state.is_quantity_loading,
                  "is-columns-modal": ""
                }, {
                  buttons: _withCtx(() => [
                    _createVNode(_component_the_button, {
                      class: "primary text small mr-2",
                      onClick: _ctx.toggleMassAvr,
                      loading: _ctx.state.orders.is_loading,
                      hint: "Массовое изменение номера АВР"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"]),
                    _createVNode(_component_the_button, {
                      class: "primary text small mr-2",
                      onClick: _ctx.toggleMassExcel,
                      loading: _ctx.state.orders.is_loading,
                      hint: "Массовая cмена даты и номера АВР"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"]),
                    _createVNode(_component_the_button, {
                      class: "primary text small mr-2",
                      loading: _ctx.state.is_exporting,
                      disabled: _ctx.state.is_exporting,
                      onClick: _ctx.exportExcel
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(" Выгрузить заказы ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ]),
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'id' && row.id)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          target: "_blank",
                          to: _ctx.getLink(row.ftl_type, row.id),
                          class: "text-blue-500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.id), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (column.key === 'dop_order_number')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.cut(row.dop_order_number, 15)), 1)
                          ], 64))
                        : (column.key === 'status')
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 2,
                              class: _normalizeClass(["font-bold small", `${_ctx.FTLStatusColors[row.status_code]}`])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.status), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : (column.key === 'manager')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(_toDisplayString(row[column.key] ? row[column.key].email : '-'), 1)
                              ], 64))
                            : (column.key === 'logist')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] ? row[column.key].email : '-'), 1)
                                ], 64))
                              : (column.key === 'created_at')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.created_at)), 1)
                                  ], 64))
                                : (column.key === 'take_at')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.take_at)), 1)
                                    ], 64))
                                  : (column.key === 'status_on_tne_way')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.status_on_tne_way)), 1)
                                      ], 64))
                                    : (column.key === 'delivered_at')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                          _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.delivered_at)), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                                        ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_button_dropdown, {
                      class: "w-min",
                      icon: "fas fa-ellipsis-h"
                    }, {
                      default: _withCtx(() => [
                        (row.id && _ctx.havePermissions(['cabinet-ftl-order-send-billing']))
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              class: "small primary mr-2",
                              loading: _ctx.state.orders.is_loading,
                              onClick: ($event: any) => (_ctx.throwInBilling(row.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Прокинуть в биллинг ")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_the_button, {
                          class: "small primary mr-2",
                          loading: _ctx.state.orders.is_loading,
                          onClick: ($event: any) => (_ctx.onOpenRequestForPayment(row.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Сделать запрос ")
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit", "quantity-loading"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}